import PropTypes from 'prop-types';
import { Alert, Card, CardContent, CardHeader, Typography } from '@mui/material';

const Instruction = ({ alertInfo = false, data, isModal, title }) => {
  if (!data || !data.length) {
    return;
  }

  // Box shadow on in SiteSheetPage, off in ShiftModal
  const variant = isModal ? 'outlined' : null;

  return (
    <Card id="instructions-card" variant={variant}>
      <CardHeader id="site-instructions" title={title} />
      <CardContent>
        {!alertInfo ? (
          <Typography id="instructions-content" component="pre">
            {data}
          </Typography>
        ) : (
          <Alert severity="info">{data}</Alert>
        )}
      </CardContent>
    </Card>
  );
};
Instruction.propTypes = {
  alertInfo: PropTypes.bool,
  data: PropTypes.string,
  isModal: PropTypes.bool,
  title: PropTypes.string
};

export default Instruction;
